module.exports = __webpack_public_path__ + "static/media/bts_lalela_170707_014_small.b8c00277.jpg";